import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { HelpCircle } from "lucide-react";
import api from '../../service/api';
import { proximaEtapa, textoProximaEtapa } from '../../data/fluxoAvaliacao';
import '../../css/Anamnese.css';
import '../../css/style.css';
import ImagensSilhuetas from '../../images/anamneseMulhersCorpos.png';

// Dados das perguntas
const PERGUNTAS = [
    { id: 0, texto: "1. Quando você começou a ganhar peso? Por favor, seja específico (ano, contexto, se foi por conta de algum trauma):", tipo: "text", placeholder: "Descreva o ano e o contexto aqui..." },
    { id: 1, texto: "2. Qual o peso máximo que você atingiu na vida?", tipo: "text", placeholder: "Ex: 115 Kg" },
    { id: 2, texto: "3. Quantas vezes já fez algo para emagrecer (dietas, exercício, remédios, cirurgias)?", tipo: "radio" },
    { id: 3, texto: "4. O que você fez para emagrecer e que deu certo?", tipo: "checkbox", temOutros: true },
    { id: 4, texto: "5. O que você fez para emagrecer e que deu errado?", tipo: "checkbox", temOutros: true },
    { id: 5, texto: "6. Quais são os seus objetivos com o programa de treinamento?", tipo: "checkbox", temOutros: true },
    { id: 6, texto: "7. Qual sua disponibilidade para treinar (Dias na semana e minutos por dia)?", tipo: "text", placeholder: "Ex: 4 dias, 60 min" },
    { id: 7, texto: "8. Quais são os tipos de exercícios físicos que você GOSTA de fazer?", tipo: "checkbox", temOutros: true },
    { id: 8, texto: "9. Quais são os tipos de exercícios físicos que você NÃO GOSTA de fazer?", tipo: "checkbox", temOutros: true },
    { id: 9, texto: "10. Você tem algumas das doenças ou condições listadas abaixo que foi diagnosticada por um médico?", tipo: "checkbox", temOutros: true },
    { id: 10, texto: "11. Você já fez uso de algum medicamento para emagrecer? (Se sim, informe o nome e quantos kg perdeu)", tipo: "text", placeholder: "Ex: Não / Sim, usei Ozempic e perdi 12kg" },
    { id: 11, texto: "12. Atualmente, você está fazendo uso de algum remédio de forma crônica (uso todos os dias)? Se sim, liste-os:", tipo: "text", placeholder: "Ex: Não / Sim: Losartana e Fluoxetina" },
    { id: 12, texto: "13. Nos últimos 15 dias, você sentiu alguma dor no corpo?", tipo: "radio" },
    { id: 13, texto: "14. Nos últimos 15 dias, você sentiu dor nos ossos, músculos, articulações ou em qualquer parte do corpo no REPOUSO?", tipo: "radio" },
    { id: 14, texto: "15. Assinale os descritores que caracterizam a sua dor mais importante quando você está em REPOUSO:", tipo: "checkbox" },
    { id: 15, texto: "16. Informe as regiões do corpo onde você sente dor DURANTE O EXERCÍCIO FÍSICO e suas respectivas notas de 0 a 10:", tipo: "text", placeholder: "Ex: Joelho direito - nota 6, Lombar - nota 4 / Não sinto dores no treino" },
    { id: 16, texto: "17. Assinale os descritores que caracterizam a sua dor mais importante DURANTE O EXERCÍCIO FÍSICO:", tipo: "checkbox" },
    { id: 17, texto: "18. As dores corporais que sente quando está em EXERCÍCIO FÍSICO te impedem de fazer atividades simples do dia a dia? (Se sim, quais?)", tipo: "text", placeholder: "Ex: Não / Sim, impede de subir escadas e agachar para pegar objetos" },
    { id: 18, texto: "19. Na sua percepção, as dores corporais estão prejudicando os movimentos que você faz quando está em ESFORÇO? (Se sim, quais?)", tipo: "text", placeholder: "Ex: Não / Sim, caminhar rápido e carregar peso" },
    { id: 19, texto: "20. Você faz exame de sangue pelo menos uma vez ao ano?", tipo: "radio" },
    { id: 20, texto: "21. Considerando o último exame de sangue realizado, você apresenta alguma das condições abaixo?", tipo: "checkbox" },
    { id: 21, texto: "22. Considerando um dia comum de semana, quantas horas por dia você dorme?", tipo: "text", placeholder: "Ex: 7 horas" },
    { id: 22, texto: "23. Você acorda cansado?", tipo: "radio" },
    { id: 23, texto: "24. Dê uma nota de 0 a 10 para a qualidade do seu sono (reparação):", tipo: "radio" },
    { id: 24, texto: "25. Espaço destinado para escrever qualquer observação relevante que você julgue necessária para o treinador:", tipo: "text", placeholder: "Sinta-se à vontade para escrever..." }
];

const OPCOES_RESPOSTAS = [
    { id: 0, opcoes: [] },
    { id: 1, opcoes: [] },
    { id: 2, opcoes: ["1 vez", "2 vezes", "3 vezes", "entre 4 e 6 vezes", "entre 7 e 10 vezes", "+ de 10 vezes"] },
    { id: 3, opcoes: ["somente exercício", "somente dieta", "somente remédio", "somente cirurgia", "exercício + dieta", "exercício + remédio", "dieta + remédio", "dieta + exercício + remédio"] },
    { id: 4, opcoes: ["somente exercício", "somente dieta", "somente remédio", "somente cirurgia", "exercício + dieta", "exercício + remédio", "dieta + remédio", "dieta + exercício + remédio"] },
    { id: 5, opcoes: ["Prevenção", "Condicionamento Físico", "Emagrecimento", "Ganho de massa muscular", "Controlar doenças", "Diminuir dores corporais"] },
    { id: 6, opcoes: [] },
    { id: 7, opcoes: ["musculação", "treino com o peso do corpo", "esteira", "bike", "transport", "natação", "lutas"] },
    { id: 8, opcoes: ["musculação", "treino com o peso do corpo", "esteira", "bike", "transport", "natação", "lutas"] },
    { id: 9, opcoes: ["Diabetes tipo I", "Diabetes tipo II", "Esteatose hepática não-alcoólica", "Hipertensão arterial", "Síndrome metabólica", "Colesterol elevado", "Dislipidemia", "Insuficiência cardíaca", "Doença arterial coronariana", "Osteoporose", "Artrite", "Artrose", "Câncer", "Asma", "DPOC", "Hérnia de disco", "Depressão", "Ansiedade", "Nenhuma condição"] },
    { id: 10, opcoes: [] },
    { id: 11, opcoes: [] },
    { id: 12, opcoes: ["SIM", "NÃO"] },
    { id: 13, opcoes: ["SIM", "NÃO"] },
    { id: 14, opcoes: ["Não sinto dor em repouso", "Terrível", "Insuportável", "Enlouquecedora", "Profunda", "Intensa", "Desconfortável"] },
    { id: 15, opcoes: [] },
    { id: 16, opcoes: ["Não sinto dor em exercício", "Terrível", "Insuportável", "Enlouquecedora", "Profunda", "Intensa", "Desconfortável"] },
    { id: 17, opcoes: [] },
    { id: 18, opcoes: [] },
    { id: 19, opcoes: ["SIM", "NÃO"] },
    { id: 20, opcoes: ["glicose elevada no sangue", "insulina elevada no sangue", "colesterol elevado no sangue", "LDL-colesterol elevado no sangue", "HDL-baixo no sangue", "Cortisol elevado no sangue", "Nenhuma das alternativas / Exame normal"] },
    { id: 21, opcoes: [] },
    { id: 22, opcoes: ["SIM", "NÃO"] },
    { id: 23, opcoes: ["0 (Não reparador)", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10 (Totalmente reparador)"] },
    { id: 24, opcoes: [] }
];

function AnamneseMulheresEmagrecimento({ setPerfilAnamnese, setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {

    // Navegação entre etapas
    const [etapa, setEtapa] = useState(1);
    const totalEtapas = 5;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    const avancarEtapa = () => {
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    // Modal para próxima etapa
    const [isNextModal, setIsNextModal] = useState(false);
    const openNextModal = () => {
        console.log(respostasSelecionadas);
        setIsNextModal(true);
    };
    const closeNextModal = () => {
        setIsNextModal(false);
    };

    // Popup de informações
    const [showInfo, setShowInfo] = useState(false);

    // Modal para selecionar a anamnese
    const [isAnamneseTypeModal, setIsAnamneseTypeModal] = useState(false);
    const openAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(true);
    };
    const closeAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(false);
    };

    const [isChoosingAnamnese, setIsChoosingAnamnese] = useState(false);
    const handleChooseAnamnese = () => {
        setIsChoosingAnamnese(true);
    };

    // SALVAR E BUSCAR NO BD - LEVI
    const [respostasSelecionadas, setRespostasSelecionadas] = useState(
        PERGUNTAS.map(p => ({ id: p.id, valor: p.tipo === 'checkbox' ? [] : "" }))
    );
    const [observacoes, setObservacoes] = useState(evaluationData?.observacoesAnamnese || "");

    const [selectedAnamnese, setSelectedAnamnese] = useState("anamneseEmagrecimento");
    // FIM

    useEffect(() => {
        if (evaluationData?.observacoesAnamnese !== undefined) {
            setObservacoes(evaluationData.observacoesAnamnese);
        }
    }, [evaluationData]);

    const handleConfirmTroca = () => {
        // Atualiza o estado no componente pai
        setPerfilAnamnese(selectedAnamnese);
        closeAnamneseTypeModal();
    };

    const atualizarResposta = (perguntaId, novoValor, tipo) => {
        setRespostasSelecionadas(prev => prev.map(item => {
            if (item.id !== perguntaId) return item;

            let valorFinal;
            if (tipo === 'checkbox') {
                const listaAtual = Array.isArray(item.valor) ? item.valor : [];
                valorFinal = listaAtual.includes(novoValor)
                    ? listaAtual.filter(v => v !== novoValor)
                    : [...listaAtual, novoValor];
            } else {
                valorFinal = novoValor;
            }
            return { ...item, valor: valorFinal };
        }));
    };

    const renderPergunta = (id) => {
        const pergunta = PERGUNTAS.find(p => p.id === id);
        if (!pergunta) return null; // Segurança caso o ID não exista

        const rObj = respostasSelecionadas.find(item => item.id === pergunta.id);
        const r = rObj ? rObj.valor : (pergunta.tipo === 'checkbox' ? [] : "");
        const opcoesDaPergunta = OPCOES_RESPOSTAS.find(opt => opt.id === pergunta.id)?.opcoes || [];

        return (
            <div className="question-item" key={pergunta.id}>
                <div className="standard-title">{pergunta.texto}</div>
                
                {pergunta.imagem && (
                    <div className="question-image-container" style={{ textAlign: 'center', margin: '10px 0' }}>
                        <img src={pergunta.imagem} alt="Referência" style={{ maxWidth: '100%', borderRadius: '8px' }} />
                    </div>
                )}

                <div className="answer-container">
                    {/* ... Seus inputs (text, checkbox, radio) continuam exatamente iguais ... */}
                    {pergunta.tipo === 'text' && (
                        <input
                            className="answer-text"
                            value={r}
                            placeholder={pergunta.placeholder}
                            onChange={e => atualizarResposta(pergunta.id, e.target.value, 'text')}
                        />
                    )}
                    {/* Mapeamento das opções e lógica de "Outros" seguem abaixo igual ao seu código original */}
                    {opcoesDaPergunta.map(opcao => (
                        <label className="answer-item" key={opcao}>
                            <input
                                type={pergunta.tipo}
                                className={`answer-${pergunta.tipo}`}
                                checked={pergunta.tipo === 'checkbox' ? r?.includes(opcao) : r === opcao}
                                onChange={() => atualizarResposta(pergunta.id, opcao, pergunta.tipo)}
                            />
                            <p className="answer-title">{opcao}</p>
                        </label>
                    ))}
                    {/* ... (manter bloco do temOutros) ... */}
                </div>
            </div>
        );
    };

    // --- LÓGICA DE DIVISÃO EM COLUNAS ---

    // 1. Filtramos as perguntas da etapa atual
    const perguntasDaEtapa = PERGUNTAS.filter((_, idx) => {
        if (etapa === 1) return idx < 8;
        if (etapa === 2) return idx >= 8 && idx < 16;
        return idx >= 16;
    });

    // 2. Calculamos o ponto médio para dividir as colunas
    const meio = Math.ceil(perguntasDaEtapa.length / 2);
    const perguntasEsquerda = perguntasDaEtapa.slice(0, meio);
    const perguntasDireita = perguntasDaEtapa.slice(meio);

    // Navegação provisória
    // A etapa seguinte depende do perfil do aluno (no idoso, Classificação Funcional).
    const proxima = proximaEtapa(aluno?.profile, 'Anamnese');
    const toAntropometria = () => {
        if (proxima) setActiveTab(proxima.chave);
    };

    const handleAnamnesisRegister = async () => {
        const payload = {
            anamnesis: respostasSelecionadas,
            observacoes,
            evaluationId
        };

        const response = await api.post(`/api/student/${aluno.id}/evaluation/anamnesis`, payload, { withCredentials: true });
        if (response.status === 200) {
            // Se o backend retornou um novo ID (pois acabou de criar no banco), nós atualizamos a página pai!
            if (response.data.evaluationId && setEvaluationId) {
                setEvaluationId(response.data.evaluationId);
            }
            if (updateEvaluationData) {
                updateEvaluationData({ anamnesis: respostasSelecionadas, observacoesAnamnese: observacoes });
            }
            openNextModal();
        }
    };

    return (
        <div className="avaliacao-container">
            <div className="avaliacao-content">
                {etapa === 1 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[0, 1, 2].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[3, 4].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 2 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[5, 6, 7].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[8, 9].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 3 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[10, 11, 12].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[13, 14, 15].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 4 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[16, 17, 18].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[19, 20].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 5 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[21, 22, 23].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[24].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                <Modal
                    isOpen={isAnamneseTypeModal}
                    onRequestClose={closeAnamneseTypeModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    {isChoosingAnamnese ? (
                        <>
                            <p className="anamnese-modal-type-p">Selecione o tipo de anamnese:</p>
                            <select 
                                className="select-anamnese"
                                value={selectedAnamnese}
                                onChange={(e) => setSelectedAnamnese(e.target.value)}
                            >
                                <option value="anamneseAdultos">Adultos</option>
                                <option value="anamneseEmagrecimento">Mulheres emagrecimento</option>
                                <option value="anamneseIdosos">Idosos</option>
                                <option value="anamneseGestantes">Gestantes</option>
                                <option value="anamnesePosParto">Pós Parto</option>
                                <option value="anamneseObesos">Obesos</option>
                                <option value="anamneseDiabetes">Diabetes</option>
                                <option value="anamneseHipertensao">Hipertensão</option>
                                <option value="anamneseDepressao">Depressao</option>
                            </select>
                            <div>
                                <button className="next-prev-button" onClick={handleConfirmTroca}>
                                    Confirmar Troca
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="anamnese-modal-type-p">
                                De acordo com o perfil do avaliado, recomenda-se<br />
                                anamnese para <span className="anamnese-modal-type-profile">Adultos</span>. Deseja
                                continuar <br /> ou escolher outra anamnese?
                            </p>
                            <div className="sub-pagination-buttons">
                                <button className="next-prev-button" type="button" onClick={closeAnamneseTypeModal}>
                                    Continuar
                                </button>
                                <button className="next-prev-button" type="button" onClick={handleChooseAnamnese}>
                                    Trocar Anamnese
                                </button>
                            </div>
                        </>
                    )}
                </Modal>

                <Modal
                    isOpen={isNextModal}
                    onRequestClose={closeNextModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">Anamnese finalizada!</p>
                    <p className="popupNext-h2">{textoProximaEtapa(proxima)}</p>
                    <div className="sub-pagination-buttons">
                        <button className="next-prev-button" type="button" onClick={toAntropometria}>
                            Sim
                        </button>
                        <button className="next-prev-button" type="button" onClick={closeNextModal}>
                            Não
                        </button>
                    </div>
                </Modal>

                {etapa === totalEtapas && (
                    <div className="anamnese-observacoes">
                        <div className="standard-title">Observações</div>
                        <textarea
                            className="anamnese-observacoes-input"
                            placeholder="Escreva observações adicionais sobre o avaliado..."
                            value={observacoes}
                            onChange={(e) => setObservacoes(e.target.value)}
                        />
                    </div>
                )}

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            {etapa > 0 && (
                                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}
                            {etapa < 5 ? (
                                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="next-prev-button" type="button" onClick={handleAnamnesisRegister}>Registrar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                    <div className="info-box-container" >
                        <div className="info-button" onClick={openAnamneseTypeModal}>
                            Trocar Anamnese
                        </div>
                        <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                            <HelpCircle size={20} />
                            Mais informações
                        </div>
                        {showInfo && (
                            <div className="info-box-content">
                                <p className="">A anamnese é a primeira etapa de uma avaliação física e consiste em uma entrevista estruturada entre o profissional
                                    de Educação Física e o avaliado. Seu objetivo é coletar informações detalhadas sobre o histórico de saúde, estilo de vida, hábitos e
                                    objetivos do indivíduo, servindo como base para um planejamento seguro e personalizado do programa de treinamento.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AnamneseMulheresEmagrecimento;